import { Card } from "../../../ui/card";
import { CompanyStats } from "../../../../types/interview";
import { Building2, CheckCircle2, Clock } from "lucide-react";
import { Progress } from "../../../ui/progress";

interface CompanyBreakdownProps {
  companies: CompanyStats[];
}

export const CompanyBreakdown = ({ companies }: CompanyBreakdownProps) => {
  return (
  <Card className="p-6 shadow-lg border-0 bg-white animate-slide-up">
      <h3 className="text-xl font-semibold mb-6 flex items-center gap-2 text-card-foreground">
        <Building2 className="w-5 h-5 text-primary" />
        Company-wise Breakdown
      </h3>
      <div className="space-y-6">
        {companies.map((company, index) => {
          const completionRate = (company.completed / company.total) * 100;
          return (
            <div key={index} className="space-y-2 p-4 rounded-lg bg-[#f7f9fc] hover:bg-[#e9ecef] transition-colors">
              <div className="flex items-center justify-between">
                <h4 className="font-semibold text-foreground">{company.companyName}</h4>
                <span className="text-sm font-medium text-muted-foreground">
                  {company.total} interviews
                </span>
              </div>
              <div className="flex items-center gap-4 text-sm">
                <div className="flex items-center gap-1 text-[#28a745] font-semibold">
                  <CheckCircle2 className="w-4 h-4" />
                  <span>{company.completed} completed</span>
                </div>
                <div className="flex items-center gap-1 text-[#ff9800] font-semibold">
                  <Clock className="w-4 h-4" />
                  <span>{company.pending} pending</span>
                </div>
              </div>
              <Progress value={completionRate} className="h-2" />
            </div>
          );
        })}
      </div>
    </Card>
  );
};
